import Lights from "./Lights.tsx";
import { RefObject, useRef } from "react";
import { Mesh } from "three";
import { useFrame } from "@react-three/fiber";
import { useSpring } from "@react-spring/web";
import { animated } from "@react-spring/three";

export default function Loading(props: any): JSX.Element {
  const loadingBox: RefObject<Mesh> = useRef<Mesh>(null);

  // TODO : not really doing anything
  const { positionY } = useSpring({
    from: { positionY: 0 },
    to: async (next) => {
      while (true) {
        await next({ positionY: 0.2 });
        await next({ positionY: -0.2 });
      }
    },
    config: { duration: 1000 },
  });

  useFrame((state, delta, frame) => {
    if (loadingBox.current) {
      const time = state.clock.getElapsedTime();
      loadingBox.current.rotation.y = time * 2;
      loadingBox.current.position.y = Math.sin(time * 4) * 0.2;
    }
  });

  return (
    <>
      <directionalLight position={[4, 4, 1]} intensity={5} />
      <ambientLight intensity={1} />
      <animated.mesh ref={loadingBox} position-y={positionY} {...props}>
        <boxGeometry args={[1, 1, 1, 2, 2, 2]} />
        <meshStandardMaterial color="red" />
      </animated.mesh>
    </>
  );
}
